'use strict';

var cov_24rlrkn1fm = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/users/editProfile/editProfile.js',
        hash = '7808b696c6ffb2325e96e0528ad673789089df4d',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/users/editProfile/editProfile.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 33
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 11
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 18,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 16
                },
                end: {
                    line: 17,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 12,
                    column: 20
                },
                end: {
                    line: 12,
                    column: 99
                }
            },
            '8': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 59
                }
            },
            '9': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 98
                }
            },
            '10': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 57
                }
            },
            '11': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 11
                }
            },
            '12': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 94
                }
            },
            '14': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 41
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 11
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 89
                }
            },
            '17': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 39,
                    column: 66
                }
            },
            '18': {
                start: {
                    line: 44,
                    column: 0
                },
                end: {
                    line: 52,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 84
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 43
                    },
                    end: {
                        line: 8,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 49
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 50
                    },
                    end: {
                        line: 10,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 56
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 19
                    },
                    end: {
                        line: 14,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 25
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 14
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                line: 22
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 4
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 17
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 26
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 27,
                        column: 65
                    },
                    end: {
                        line: 27,
                        column: 66
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 71
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 27
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 28,
                        column: 62
                    },
                    end: {
                        line: 28,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 68
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 28
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 21
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 36,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 17
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                line: 36
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 37,
                        column: 63
                    },
                    end: {
                        line: 37,
                        column: 64
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 69
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                },
                line: 37
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                }, {
                    start: {
                        line: 9,
                        column: 12
                    },
                    end: {
                        line: 18,
                        column: 13
                    }
                }],
                line: 9
            },
            '1': {
                loc: {
                    start: {
                        line: 9,
                        column: 16
                    },
                    end: {
                        line: 9,
                        column: 95
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 9,
                        column: 16
                    },
                    end: {
                        line: 9,
                        column: 50
                    }
                }, {
                    start: {
                        line: 9,
                        column: 54
                    },
                    end: {
                        line: 9,
                        column: 95
                    }
                }],
                line: 9
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditProfileController = function () {
    function EditProfileController($mdToast, AuthService, $state, $rootScope, $scope, WorkspacesTable) {
        var _this = this;

        _classCallCheck(this, EditProfileController);

        cov_24rlrkn1fm.f[0]++;
        cov_24rlrkn1fm.s[0]++;

        this.$mdToast = $mdToast;
        cov_24rlrkn1fm.s[1]++;
        this.AuthService = AuthService;
        cov_24rlrkn1fm.s[2]++;
        this.$state = $state;
        cov_24rlrkn1fm.s[3]++;
        this.workspacesTable = WorkspacesTable;

        cov_24rlrkn1fm.s[4]++;
        $scope.$watch('$ctrl.user.avatar', function () {
            cov_24rlrkn1fm.f[1]++;
            cov_24rlrkn1fm.s[5]++;

            if ((cov_24rlrkn1fm.b[1][0]++, angular.isString(_this.user.avatar)) && (cov_24rlrkn1fm.b[1][1]++, _this.user.avatar !== $rootScope.me.avatar)) {
                cov_24rlrkn1fm.b[0][0]++;
                cov_24rlrkn1fm.s[6]++;

                _this.user.$save(['avatar']).$then(function () {
                    cov_24rlrkn1fm.f[2]++;
                    cov_24rlrkn1fm.s[7]++;

                    /* eslint-disable no-undef */
                    $mdToast.show($mdToast.simple().textContent(gettext('Profile image updated')));
                    cov_24rlrkn1fm.s[8]++;
                    AuthService.refreshAuthenticatedInfo();
                }, function () {
                    cov_24rlrkn1fm.f[3]++;
                    cov_24rlrkn1fm.s[9]++;

                    /* eslint-disable no-undef */
                    $mdToast.show($mdToast.simple().textContent(gettext('An error has ocurred')));
                });
            } else {
                cov_24rlrkn1fm.b[0][1]++;
            }
        });
    }

    _createClass(EditProfileController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_24rlrkn1fm.f[4]++;
            cov_24rlrkn1fm.s[10]++;

            this.workspaces = this.workspacesTable.$search();
        }
    }, {
        key: 'changeInfo',
        value: function changeInfo() {
            var _this2 = this;

            cov_24rlrkn1fm.f[5]++;
            cov_24rlrkn1fm.s[11]++;

            this.user.$save(['name', 'email', 'nif', 'phone']).$then(function () {
                cov_24rlrkn1fm.f[6]++;
                cov_24rlrkn1fm.s[12]++;

                _this2.AuthService.refreshAuthenticatedInfo().$then(function () {
                    cov_24rlrkn1fm.f[7]++;
                    cov_24rlrkn1fm.s[13]++;

                    _this2.$mdToast.show(_this2.$mdToast.simple().textContent('Perfil actualizado!'));
                }, function () {
                    cov_24rlrkn1fm.f[8]++;
                    cov_24rlrkn1fm.s[14]++;

                    _this2.$state.go('logout');
                });
            });
        }
    }, {
        key: 'changePass',
        value: function changePass() {
            var _this3 = this;

            cov_24rlrkn1fm.f[9]++;
            cov_24rlrkn1fm.s[15]++;

            this.user.$save(['password', 'confirmPassword']).$then(function () {
                cov_24rlrkn1fm.f[10]++;
                cov_24rlrkn1fm.s[16]++;

                _this3.$mdToast.show(_this3.$mdToast.simple().textContent('Password alterada!'));
                cov_24rlrkn1fm.s[17]++;
                _this3.user.password = _this3.user.confirmPassword = null;
            });
        }
    }]);

    return EditProfileController;
}();

cov_24rlrkn1fm.s[18]++;


angular.module('app').component('editProfile', {
    templateUrl: 'app/components/users/editProfile/editProfile.html',
    controller: EditProfileController,
    bindings: {
        user: '<'
    }
});